import { Injectable, inject } from '@angular/core';
import { Firestore, collection, addDoc, query, where, getDocs, Timestamp } from '@angular/fire/firestore';

@Injectable({
    providedIn: 'root'
})
export class FeedbackService {
    firestore = inject(Firestore);

    async getUserFeedback(userId: string) {
        const q = query(
            collection(this.firestore, 'feedback'),
            where('userId', '==', userId)
        );
        const snapshot = await getDocs(q);
        const data: any[] = snapshot.docs.map(d => d.data());
        // Client side sort
        data.sort((a, b) => (b['createdAt']?.toMillis() || 0) - (a['createdAt']?.toMillis() || 0));
        return data;
    }

    async getAllFeedback() {
        const snapshot = await getDocs(collection(this.firestore, 'feedback'));
        const data: any[] = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
        data.sort((a, b) => (b['createdAt']?.toMillis() || 0) - (a['createdAt']?.toMillis() || 0));
        return data;
    }

    async submitFeedback(data: any) {
        return addDoc(collection(this.firestore, 'feedback'), {
            ...data,
            createdAt: Timestamp.now(),
            status: 'new'
        });
    }
}
